<template>
  <div id="startup-item-displayer">
    <FilterModal
      :showDialog="showDialog"
      @vertical="onVerticalFilter"
      @batch="onBatchFilter"
      @close="onFilterModalClose"
      :verticales="verticales"
      :batches="batches"
    />
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-8">
          <div class="search">
            <AutocompleteInput
              v-model="selectedItem"
              :options="startups.map(x => x.name)"
              label="Buscar startups"
              name="search"
              id="search"
            />
          </div>
        </div>
        <div class="status-bar col-12 col-md-4">
          <div class="row order-filter-bar">
            <div class="col-6 d-flex d-md-none">
              <h4 class="showingResults">Mostrando {{applyFilters.length}} startups</h4>
            </div>
            <div class="col-6 col-md-12">
              <div class="row no-gutters">
                <div class="col-6">
                  <MenuButton class="btn-middle" :text="orderTypes[order].text">
                    <md-menu-item
                      v-for="(orderType, key) in orderTypes"
                      :key="orderType.id"
                      @click="order = key"
                    >{{orderType.longText}}</md-menu-item>
                  </MenuButton>
                </div>
                <div class="col-6">
                  <SecondaryButton @click="openFiltersModal" class="btn btn-middle">Filtrar</SecondaryButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <StartupItem
        v-for="(startup, i) in applyModifiers"
        :key="i"
        :startup="startup"
        :openSidepanel="openSidepanel"
      />
      <Paginate
        v-model="currentPage"
        :page-count="numOfPages"
        :click-handler="onPageChange"
        prev-text="Anterior"
        next-text="Siguiente"
        container-class="pagination"
        class="pag"
        v-if="startups.length > perPage"
      ></Paginate>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js';
import Paginate from 'vuejs-paginate';
import StartupItem from './StartupItem.vue';
import FilterModal from './FilterModal.vue';
import AutocompleteInput from './Input/AutocompleteInput.vue';
import MenuButton from './Button/MenuButton.vue';
import SecondaryButton from './Button/SecondaryButton.vue';


export default {
  name: 'StartupItemDisplayer',
  props: {
    openSidepanel: Function,
    startups: Array,
  },
  components: {
    StartupItem,
    AutocompleteInput,
    Paginate,
    MenuButton,
    SecondaryButton,
    FilterModal,
  },
  computed: {
    selectedFondo() {
      return this.$store.state.selectedFondo;
    },
    applyFilters(){
      let res = this.startups;
      this.filters.forEach(x => res = x(res));
      return res;
    },
    applyModifiers(){
      let res = this.applyFilters;
      this.modifiers.forEach(x => res = x(res));
      return res;
    },
    numOfPages() {
      return Math.ceil(this.applyFilters.length / this.perPage);
    },
    verticales() {
      const uniqueVerticales = [];

      this.startups.map(x => x.verticales).forEach(x => {
        x.forEach(y => {
          if(y.id > 0 && !uniqueVerticales.some(z => y.id === z.id)){
            uniqueVerticales.push(y);
          }
        });
      });
      
      return uniqueVerticales.sort((a, b) => a.name.localeCompare(b.name));
    },
    batches() {
      const uniqueBatches = [];

      this.startups.map(x => x.basic.batch).forEach(x => {
        if(!uniqueBatches.some(y => y === x)){
          uniqueBatches.push(x);
        }
      });

      return uniqueBatches.sort((a, b) => a-b);
    },
  },
  watch: {
    selectedItem() {
      this.currentPage = 1;
    },
    '$store.state.selectedFondo'() {
      this.currentPage = 1;
    },
    startups(val) {
      this.fuse.setCollection(val);
    },
  },
  data() {
    return {
      perPage: 25,
      currentPage: 1,
      selectedItem: '',
      fuse: null,
      startupItemDisplayer: null,
      order: 'startupAZ',
      showDialog: false,
      batchFilter: 'all',
      verticalFilter: 'all',
      modifiers: [],
      filters: [],
      orderTypes: {
        startupAZ: {
          longText: 'Startup A - Z',
          text: 'Ordenar',
          func: results => [...results].sort(
            (a, b) => a.name.localeCompare(b.name)
          ),
        },
        startupZA: {
          longText: 'Startup Z - A',
          text: 'Z-A',
          func: results => [...results].sort(
            (a, b) => b.name.localeCompare(a.name)
          ),
        },
        verticalAZ: {
          longText: 'Vertical A - Z',
          text: 'Vert. A-Z',
          func: results => [...results].sort(
            (a, b) => {
              return a.verticales.length > 0 && b.verticales.length > 0
              ? a.verticales[0].name.localeCompare(b.verticales[0].name)
              : 1
            } 
          ),
        },
        verticalZA: {
          longText: 'Vertical Z - A',
          text: 'Vert. Z-A',
          func: results => [...results].sort(
            (a, b) => {
              return a.verticales.length > 0 && b.verticales.length > 0
              ? b.verticales[0].name.localeCompare(a.verticales[0].name)
              : 1
            } 
          ),
        },
        valMm: {
          longText: 'Valuación Mayor a menor',
          text: 'Mayor val.',
          func: results => [...results].sort(
            (a, b) => b.basic.valuacion-a.basic.valuacion
          ),
        },
        valmM: {
          longText: 'Valuación Menor a mayor',
          text: 'Menor val.',
          func: results => [...results].sort(
            (a, b) => a.basic.valuacion-b.basic.valuacion
          ),
        },
        invMm: {
          longText: 'Total invertido Mayor a menor',
          text: 'Mayor inv.',
          func: results => [...results].sort(
            (a, b) => {
              if(selectedFondo === 'GRIDX2') {
                return (b.basic.invertido_gridx_2+b.basic.invertido_gridx_2_follow)-(a.basic.invertido_gridx_2+a.basic.invertido_gridx_2_follow);
              }

              return (b.basic.invertido_gridx+b.basic.invertido_gridx_follow)-(a.basic.invertido_gridx+a.basic.invertido_gridx_follow);
            }
          ),
        },
        invmM: {
          longText: 'Total invertido Menor a mayor',
          text: 'Menor inv.',
          func: results => [...results].sort(
            (a, b) => {
              if(selectedFondo === 'GRIDX2') {
                return (a.basic.invertido_gridx_2+a.basic.invertido_gridx_2_follow)-(b.basic.invertido_gridx_2+b.basic.invertido_gridx_2_follow)
              }
              return (a.basic.invertido_gridx+a.basic.invertido_gridx_follow)-(b.basic.invertido_gridx+b.basic.invertido_gridx_follow)
            }
          ),
        },
      },
    };
  },
  mounted() {
    this.fuse = new Fuse(this.startups, { keys: ['name'] });
    
    this.startupItemDisplayer = 
      document.getElementById('startup-item-displayer');

    // Search Filter
    this.filters.push(results => 
      !this.fuse || !this.selectedItem 
        ? results
        : this.fuse.search(this.selectedItem).map((x) => x.item)
    );

    // Vertical Filter
    this.filters.push(results => {
      if(this.verticalFilter === 'all') return results;
      return results.filter(x => x.verticales.some(y => y.id === this.verticalFilter));
    });

    // Batch Filter
    this.filters.push(results => {
      if(this.batchFilter === 'all') return results;
      return results.filter(x => x.basic.batch === +this.batchFilter);
    });

    // Order Modifier
    this.modifiers.push(results => this.orderTypes[this.order].func(results));
    
    // Pagination Modifier
    this.modifiers.push(results => results.slice(this.perPage * (this.currentPage - 1), (this.perPage * this.currentPage)));
  },
  methods: {
    onFilterModalClose(){
      this.showDialog = false;
    },
    onBatchFilter(val){
      this.batchFilter = val;
    },
    onVerticalFilter(val){
      this.verticalFilter = val;
    },
    openFiltersModal(){
      this.showDialog = true;
    },
    onPageChange(page) {
      this.startupItemDisplayer.scrollIntoView();
      this.currentPage = page;
    },
  },
};
</script>

<style lang="scss">
#startup-item-displayer{
  position: relative;
}
.btn-middle {
  display: block;
  margin: 0 auto !important;

  button {
    margin: 0 auto !important;
    display: block;
  }
}

.pag.pagination {
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
  display: block;
  width: fit-content;
  margin: 30px auto;

  li {
    display: inline-block;
    text-align: -webkit-match-parent;

    &.active {
      background: #ff5f3c;

      a {
        background: #ff5f3c;
        color: #fff;
      }
    }

    a {
      position: relative;
      display: block;
      padding: 0.5rem 0.75rem;
      margin-left: -1px;
      line-height: 1.25;
      background-color: #fff;
      border: 1px solid #dee2e6;
    }

    &:first-child {
      a {
        margin-left: 0;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
      }
    }

    &:last-child {
      a {
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
      }
    }
  }
}
</style>

<style scoped lang="scss">
@media (min-width: 768px) {
  .order-filter-bar {
    margin-top: 27px;
  }
}

.search {
  margin-bottom: 15px;
  @media (min-width: 768px) {
    margin-bottom: 30px;
  }
}
.btn {
  font-weight: normal !important;
  font-size: 14px !important;
  height: 33px !important;

  @media (min-width: 768px) {
    font-weight: bold !important;
    font-size: 16px !important;
  }
}
.status-bar {
  margin-bottom: 10px;
}
h4.showingResults {
  font-weight: 600;
  font-size: 12px;
  color: #330e2f;
  margin: 0;
  margin-bottom: 7px;
  position: absolute;
  bottom: 0;
}
</style>
